import {firestore} from "@web/lib/firebase";
import {doc, DocumentData, DocumentSnapshot, FirestoreError, Timestamp} from "firebase/firestore";
import {useDocumentData} from "react-firebase-hooks/firestore";
import compact from "lodash/compact.js";

/**
 * @summary useDocumentFirestore
 * @param {string|string[]|undefined} documentPath
 * @param {object} [converter]
 * @return {[(DocumentData | undefined), boolean, (FirestoreError | undefined), (DocumentSnapshot<DocumentData> | undefined)]}
 */
export default function useDocumentFirestore(documentPath, converter = null) {
  if (!documentPath) {
    return useDocumentData(null);
  }

  const path = Array.isArray(documentPath) ?
    documentPath.join("/") :
    documentPath;

  const validPath =
    !!path &&
    (path.indexOf("//") === -1) &&
    (compact(path.split("/")).length % 2 === 0);

  if (!validPath) {
    console.warn("Invalid path", path, compact(path.split("/")).length % 2);
  }

  // {
  //   toFirestore: (data) => {
  //     const serializedData = {...data};
  //     Object.keys(serializedData).forEach(key => {
  //       if (serializedData[key] instanceof Date) {
  //         serializedData[key] = serializedData[key].toISOString();
  //       }
  //     });
  //     return serializedData;
  //   },
  //     fromFirestore: (snapshot) => {
  //   const data = snapshot.data();
  //   Object.keys(data).forEach(key => {
  //     if (typeof data[key] === "string" && !isNaN(Date.parse(data[key]))) {
  //       data[key] = new Date(data[key]);
  //     }
  //   });
  //   return data;
  // }
  // }
  // )) || null, {
  //   snapshotOptions: {serverTimestamps: "estimate"},
  //   initialValue: {},
  // }

  return useDocumentData(
    (validPath && doc(firestore, path).withConverter(converter)) || null, {
      snapshotOptions: {serverTimestamps: "estimate"}, // todo - changed 03/11/2025
      // initialValue: {},
    });
}
